import { Option as RCOption } from 'rc-select';
import { OptionProps } from 'rc-select/lib/Option';

export interface IOptionProps extends OptionProps {}

const Option = RCOption;

export default Option;
